const abcToItDecoder = (locale: string): {[solfa: string]: string} => ({
    c: "DO",
    d: "RE",
    e: "MI",
    f: "FA",
    g: "SOL",
    a: "LA",
    h: locale === "it" ? "TI" : "SI",
});

const decodeAbcToIt = (label: string, locale: "es" | "it") => {
    let abc = label.slice(0, 1);
    const isTripleUpper = label.indexOf("’’’") !== -1;
    const isDoubleUpper = !isTripleUpper && label.indexOf("’’") !== -1;
    const isUpper = !isTripleUpper && !isDoubleUpper && label.indexOf("’") !== -1;
    const isLower = abc === abc.toUpperCase();
    abc = abc.toLowerCase();
    const isDoubleSharp = label.indexOf("iszisz") !== -1;
    const isSharp = !isDoubleSharp && label.indexOf("isz") !== -1;
    const isDoubleFlat = label.slice(0, 3).toLowerCase() === "bebé" || (label.indexOf("szesz") !== -1);
    const isFlat = !isDoubleFlat && (abc === "b" || (!isDoubleSharp && !isSharp && label.indexOf("sz") !== -1));
    if (abc === "b") abc = "h";

    let result = abcToItDecoder(locale)[abc];
    if (isSharp || isDoubleSharp) {
        const sharpener = abc === "e" || abc === "h" ? "E" : "I" + (abc === "g" ? "L" : "");
        result = `${result.slice(0, 1)}${sharpener}${isDoubleSharp ? sharpener : ""}`;
    } else if (isFlat || isDoubleFlat) {
        const flattener = abc === "f" || abc === "a" ? "O" : "A" + (abc === "g" ? "L" : "");
        result = `${result.slice(0, 1)}${flattener}${isDoubleFlat ? flattener : ""}`;
    }

    if (isUpper) {
        result = `${result}’`;
    } else if (isDoubleUpper) {
        result = `${result}’’`;
    } else if (isTripleUpper) {
        result = `${result}’’’`;
    } else if (isLower) {
        result = `${result},`;
    }
    return result;
};

const abcToElDecoder: {[solfa: string]: string} = {
    c: "ΝΤΟ",
    d: "ΡΕ",
    e: "ΜΙ",
    f: "ΦΑ",
    g: "ΣΟΛ",
    a: "ΛΑ",
    h: "ΣΙ",
};

const decodeToEl = (label: string) => {
    let abc = label.slice(0, 1);
    const isTripleUpper = label.indexOf("’’’") !== -1;
    const isDoubleUpper = !isTripleUpper && label.indexOf("’’") !== -1;
    const isUpper = !isTripleUpper && !isDoubleUpper && label.indexOf("’") !== -1;
    const isLower = abc === abc.toUpperCase();
    abc = abc.toLowerCase();
    const isDoubleSharp = label.indexOf("iszisz") !== -1;
    const isSharp = !isDoubleSharp && label.indexOf("isz") !== -1;
    const isDoubleFlat = label.slice(0, 3).toLowerCase() === "bebé" || (label.indexOf("szesz") !== -1);
    const isFlat = !isDoubleFlat && (abc === "b" || (!isDoubleSharp && !isSharp && label.indexOf("sz") !== -1));
    if (abc === "b") abc = "h";

    let result = abcToElDecoder[abc];
    if (isSharp) {
        result = `${result}#`;
    } else if (isFlat) {
        result = `${result}b`;
    } else if (isDoubleSharp) {
        result = `${result}×`;
    } else if (isDoubleFlat) {
        result = `${result}bb`;
    }
    if (isUpper) {
        result = `${result}’`;
    } else if (isDoubleUpper) {
        result = `${result}’’`;
    } else if (isTripleUpper) {
        result = `${result}’’’`;
    } else if (isLower) {
        result = `${result},`;
    }

    return result;
}

const decodeAbcToEn = (label: string) => {
    if (label.slice(1, 7) === "iszisz") {
        label = label.replace("iszisz", "×");
    } else if (label.slice(1, 4) === "isz") {
        label = label.replace("isz", "#");
    } else if (label.slice(1, 4) === "ebé") {
        label = label.replace("ebé", "b");
    } else if (label.slice(1, 2) === "b") {
        label = label.replace("b", "bb");
    } else if (label.slice(1, 6) === "szasz") {
        label = label.replace("szasz", "bb");
    } else if (label.slice(1, 6) === "szesz") {
        label = label.replace("szesz", "bb");
    } else if (label.slice(1, 7) === "eszesz") {
        label = label.replace("eszesz", "bb");
    } else if (label.slice(1, 4) === "esz") {
        label = label.replace("esz", "b");
    } else if (label.slice(1, 3) === "sz") {
        label = label.replace("sz", "b");
    }
    if (label.slice(0, 1) === "B") {
        label = label.replace("B", "Bb");
    } else if (label.slice(0, 1) === "b") {
        label = label.replace("b", "bb");
    } else if (label.slice(0, 1) === "H") {
        label = label.replace("H", "B");
    } else if (label.slice(0, 1) === "h") {
        label = label.replace("h", "b");
    }
    return label;
};

const decodeAbcToLt = (label: string) => {
    if (label.slice(1, 7) === "iszisz") {
        label = label.replace("iszisz", "×");
    } else if (label.slice(1, 4) === "isz") {
        label = label.replace("isz", "#");
    } else if (label.slice(1, 4) === "ebé") {
        label = label.replace("ebé", "b");
    } else if (label.slice(1, 2) === "b") {
        label = label.replace("b", "bb");
    } else if (label.slice(1, 6) === "szasz") {
        label = label.replace("szasz", "bb");
    } else if (label.slice(1, 6) === "szesz") {
        label = label.replace("szesz", "bb");
    } else if (label.slice(1, 7) === "eszesz") {
        label = label.replace("eszesz", "bb");
    } else if (label.slice(1, 4) === "esz") {
        label = label.replace("esz", "b");
    } else if (label.slice(1, 3) === "sz") {
        label = label.replace("sz", "b");
    }
    return label;
};

export const decodeToGerman = (label: string) => {
    return label.replace(/sz/g, "s");
};

export const localizeAbc = (letter: string, locale: string) => {
    switch (locale) {
        case "it":
            return decodeAbcToIt(letter, "it");
        case "ca":
        case "es":
            return decodeAbcToIt(letter, "es");
        case "hu":
            return letter;
        case "hr":
        case "et":
        case "nl":
        case "pl":
            return decodeToGerman(letter);
        case "el":
            return decodeToEl(letter);
        case "lt":
            return decodeAbcToLt(letter);
        default:
            return decodeAbcToEn(letter);
    }
};

export const ABCnames = [
    { label: "c’’’", value: 13 },
    { label: "cesz’’’", value: 12 },
    { label: "hisz’’", value: 13 },
    { label: "h’’", value: 12 },
    { label: "b’’", value: 11 },
    { label: "aisz’’", value: 11 },
    { label: "a’’", value: 10 },
    { label: "asz’’", value: 9 },
    { label: "gisz’’", value: 9 },
    { label: "g’’", value: 8 },
    { label: "gesz’’", value: 7 },
    { label: "fisz’’", value: 7 },
    { label: "f’’", value: 6 },
    { label: "fesz’’", value: 5 },
    { label: "eisz’’", value: 6 },
    { label: "e’’", value: 5 },
    { label: "esz’’", value: 4 },
    { label: "disz’’", value: 4 },
    { label: "d’’", value: 3 },
    { label: "desz’’", value: 2 },
    { label: "cisz’’", value: 2 },
    { label: "c’’", value: 1 },
    { label: "cesz’’", value: 0 },
    { label: "hisz’", value: 1 },
    { label: "h’", value: 0 },
    { label: "b’", value: -1 },
    { label: "aisz’", value: -1 },
    { label: "a’", value: -2 },
    { label: "asz’", value: -3 },
    { label: "gisz’", value: -3 },
    { label: "g’", value: -4 },
    { label: "gesz’", value: -5 },
    { label: "fisz’", value: -5 },
    { label: "f’", value: -6 },
    { label: "fesz’", value: -7 },
    { label: "eisz’", value: -6 },
    { label: "e’", value: -7 },
    { label: "esz’", value: -8 },
    { label: "disz’", value: -8 },
    { label: "d’", value: -9 },
    { label: "desz’", value: -10 },
    { label: "cisz’", value: -10 },
    { label: "c’", value: -11 },
    { label: "cesz’", value: -12 },
    { label: "hisz", value: -11 },
    { label: "h", value: -12 },
    { label: "b", value: -13 },
    { label: "aisz", value: -13 },
    { label: "a", value: -14 },
    { label: "asz", value: -15 },
    { label: "gisz", value: -15 },
    { label: "g", value: -16 },
    { label: "gesz", value: -17 },
    { label: "fisz", value: -17 },
    { label: "f", value: -18 },
    { label: "fesz", value: -19 },
    { label: "eisz", value: -18 },
    { label: "e", value: -19 },
    { label: "esz", value: -20 },
    { label: "disz", value: -20 },
    { label: "d", value: -21 },
    { label: "desz", value: -22 },
    { label: "cisz", value: -22 },
    { label: "c", value: -23 },
    { label: "cesz", value: -24 },
    { label: "Hisz", value: -23 },
    { label: "H", value: -24 },
    { label: "B", value: -25 },
    { label: "Aisz", value: -25 },
    { label: "A", value: -26 },
    { label: "Asz", value: -27 },
    { label: "Gisz", value: -27 },
    { label: "G", value: -28 },
];

export const ABCOptions = (locale: string) =>
    ABCnames.map(abc => {
        return {
            value: abc.label,
            label: localizeAbc(abc.label, locale),
        };
    }).reverse();

export const pianoParser = [5, 0, 7, 2, 9, 4, 11];
